import { Radio, FormControlLabel, RadioGroup } from '@material-ui/core';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';

let theme = createTheme({
  palette: {
    primary: {
      main: `${process.env.REACT_APP_SELLER_COLOR}`,
    },
  },
  overrides: {
    MuiRadio: {
      root: {
        // círculo não-selecionado visível no fundo dark
        color: 'rgba(255, 255, 255, 0.5)',
      },
    },
    MuiFormControlLabel: {
      label: {
        fontSize: '0.9rem',
      },
    },
  },
});

let RadioButton = (props) => {
  return <RadioGroup row name={props.name} value={props.value} onChange={props.change}>
    <ThemeProvider theme={theme}>
    {props.data.map((obj, index) => {
      return <FormControlLabel
        key={index}
        value={obj.value}
        control={<Radio color="primary"/>}
        label={obj.label}
        labelPlacement="end"
        disabled={props.disabled}
        style={{ color: props.labelColor || '#cbd5e1' }}
      />
    })}
    </ThemeProvider>
  </RadioGroup>
}

export default RadioButton
